import { render } from "./FoodPlan.vue?vue&type=template&id=f8d623fa&scoped=true"
import script from "./FoodPlan.vue?vue&type=script&lang=js"
export * from "./FoodPlan.vue?vue&type=script&lang=js"

import "./FoodPlan.vue?vue&type=style&index=0&id=f8d623fa&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d623fa"]])

export default __exports__